import Button from 'tio-ui/components/button';
import { t } from 'ember-intl';
import Modal from 'tio-ui/components/modal';
import type { TOC } from '@ember/component/template-only';

export interface ErrorModalComponentSignature {
  Args: {
    isOpen: boolean;
    onSubmit: () => void;
  };
}

const ErrorModalComponent: TOC<ErrorModalComponentSignature> = <template>
  <Modal
    data-test-error-modal
    @isOpen={{@isOpen}}
    @onClose={{@onSubmit}}
    @allowCloseButton={{false}}
    @closeOnEscapeKey={{false}}
    @closeOnOutsideClick={{false}}
    class="min-h-64"
  >
    <:header>{{t "login.reset_password_error"}}</:header>
    <:body>{{t "login.reset_password_error_body"}}</:body>
    <:footer>
      <Button {{on "click" @onSubmit}} @intent="primary">
        {{t "login.back_to_login"}}
      </Button>
    </:footer>
  </Modal>
</template>;

export default ErrorModalComponent;
